export default "__VITE_ASSET__CjtkqPZL__"